import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Button.scss";
import { BUTTON_TYPES } from "./ButtonTypes";
import { TEXT_SIZES } from "../../../constants";

const LinkButton = ({
  id,
  children,
  ariaLabel,
  additionalClasses,
  buttonRef,
  dataTestId,
  href,
  isExternal = false,
  isSelected,
  isTab,
  size = TEXT_SIZES.london2,
  type,
}) => {
  const linkClasses = classNames(styles.button, styles[type], styles[size], {
    [additionalClasses]: !!additionalClasses,
  });

  return (
    <a
      className={linkClasses}
      id={id}
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      aria-label={ariaLabel}
      ref={buttonRef}
      data-testid={dataTestId}
      role={isTab ? "tab" : "link"}
      aria-selected={isSelected}
    >
      {children}
    </a>
  );
};

const Element = () =>
  typeof Element === "undefined" ? function () {} : Element;

LinkButton.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  additionalClasses: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BUTTON_TYPES)),
  size: PropTypes.oneOf(Object.values(TEXT_SIZES)),
  ariaLabel: PropTypes.string,
  buttonRef: PropTypes.shape({ current: PropTypes.instanceOf(Element()) }),
  dataTestId: PropTypes.string,
  href: PropTypes.string.isRequired,
  isTab: PropTypes.bool,
  isSelected: PropTypes.bool,
  isExternal: PropTypes.bool,
};

export default LinkButton;
